'use client';
import { ContactInfo as SharedContactInfo } from '@launchstore/shared-puck';
import type { ContactInfoProps } from '@launchstore/shared-puck';
export const ContactInfo: any = SharedContactInfo;
export type { ContactInfoProps };
export default ContactInfo;
